export interface BannerSlide {
  title: string;
  subtitle: string;
  ctaLabel: string;
  href: string;
  imageUrl: string;
  badge?: string;
}

export const siteStatic = {
  banner: {
    title: "NomadShop — Солонгосын бараа",
    subtitle: "Монголд хүргэлт. Баталгаатай борлуулагчид. QPay-аар төлбөр төлөх.",
    ctaPrimary: { label: "Бараа үзэх", href: "/products" },
    ctaSecondary: { label: "Хэрхэн ажилладаг вэ", href: "/about" },
  },
  bannerCarousel: {
    slides: [
      {
        title: "Солонгосоос шууд — Шинэ бараанууд",
        subtitle: "Арьс арчилгаа • Витамин • Электроник",
        ctaLabel: "Бараа үзэх",
        href: "/products",
        imageUrl: "https://picsum.photos/seed/nomadnet-banner-1/1400/500",
        badge: "Шинэ",
      },
      {
        title: "Хямдрал, шинэ ирэлтүүдийг үзэх",
        subtitle: "Онцгой хямдралтай бараанууд",
        ctaLabel: "Хямдралтай бараа",
        href: "/products",
        imageUrl: "https://picsum.photos/seed/nomadnet-banner-2/1400/500",
        badge: "Хямдрал",
      },
      {
        title: "Гоо сайхан, эрүүл мэнд",
        subtitle: "Чанартай бараа, найдвартай хүргэлт",
        ctaLabel: "Дэлгэрэнгүй",
        href: "/products",
        imageUrl: "https://picsum.photos/seed/nomadnet-banner-3/1400/500",
      },
    ] as BannerSlide[],
  },
  footer: {
    about: {
      title: "Сайтын тухай",
      text: "NomadShop — Монголын худалдан авагчдад зориулсан Солонгосын барааны зах зээл. Бид бараа цуглуулж, борлуулагчдад туслаж, төлбөрийг хялбар болгодог.",
    },
    qna: {
      title: "Асуулт хариулт",
      items: [
        { q: "Захиалга хэрхэн хийх вэ?", a: "Бараа сонгоод, сагсанд нэмээд захиалга хий. Дараа нь QPay-аар төлбөр төлөх." },
        { q: "Хүргэлт хэрхэн ажилладаг вэ?", a: "Төлбөр төлсний дараа борлуулагч илгээлт бэлтгэнэ. Захиалгын статус хувийн кабинетэд шинэчлэгдэнэ." },
        { q: "Ямар төлбөрийн арга хэлбэрүүд байдаг вэ?", a: "Одоогоор — QPay. Бусад арга хэлбэрийг дараа нэмнэ." },
        { q: "Асуудал гарвал юу хийх вэ?", a: "Бидэнд дэмжлэгтэй холбогдоорой — холбоо барих мэдээлэл доор байна." },
      ],
    },
    links: {
      title: "Мэдээлэл",
      items: [
        { label: "Каталог", href: "/products" },
        { label: "Хүслийн жагсаалт", href: "/wishlist" },
        { label: "Бидний тухай", href: "/about" },
      ],
    },
    contacts: {
      title: "Холбоо барих",
      items: [
        { label: "Имэйл: support@nomadshop.mn", href: "mailto:support@nomadshop.mn" },
        { label: "Telegram: @nomadshop", href: "https://t.me/nomadshop" },
      ],
      note: "Бид ажлын цагт хариулна. Хэрэв асуудал яаралтай бол Telegram-аар бичнэ үү.",
    },
    bottom: `© 2024 NomadShop. Бүх эрх хуулиар хамгаалагдсан.`,
  },
};

